import { CompanyDetailsTabController } from '../controller/CompanyDetailsTabController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { getContext } from '../../../../componentHelpers/getters';
import { CompanyData } from '../../../types/company-data';
import { Observable } from 'rxjs';
import { CompanyType } from '../../../types/company-type';
import { DeepPartial } from 'typeorm';
import { SubscriptionType } from '../../../../license/types/SubscriptionType';

export class CompanyDetailsTabWebComponent extends BaseWebComponentElement {
  public controller!: CompanyDetailsTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyDetailsTabController,
    });
  }

  public get context(): CompanyActionContext {
    return getContext.bind(this)();
  }

  public get company(): CompanyData {
    return JSON.parse(this.getAttribute('data-company') || '');
  }

  public set company(company: CompanyData) {
    this.setAttribute('data-company', JSON.stringify(company));
    this.controller.view.setCompany(company);
  }

  public get hasUnsavedChanges(): boolean {
    return this.detailsForm.hasUnsavedChanges;
  }

  public get valid$(): Observable<boolean> {
    return this.detailsForm.valid$;
  }

  public get value(): DeepPartial<CompanyData & { subscription: SubscriptionType; addUser: boolean }> {
    return this.detailsForm.value;
  }

  public setEditedCompanyData(company: CompanyData) {
    this.detailsForm.setEditedCompanyData(company);
  }

  public get isReadOnly(): boolean {
    return this.detailsForm.isReadOnly;
  }

  public refreshInitialFormValue(): void {
    return this.detailsForm.refreshInitialFormValue();
  }

  public updateManageNetworkSection(showWarnings: boolean): void {
    this.detailsForm.updateManageNetworkSection(showWarnings);
  }

  public setupMdrContactDetailsSection(): void {
    this.detailsForm.setupMdrContactDetailsSection();
  }

  public getCompanyType(): CompanyType {
    return this.detailsForm.getCompanyType();
  }

  public discardFormChanges(): void {
    return this.detailsForm.discardFormChanges();
  }

  public get detailsForm() {
    return this.controller.view.dom.$companyDetailsForm;
  }
}
